<template>
  <div>
    <div class="tw-px-5">
      <div style="width: 100%" class="q-pa-sm"></div>
      <jt-data-table
        id="jtDataTable"
        :api-mode="false"
        :data="dataTable"
        :fields="columns"
        :is-paginated="false"
        row-buttons
        noneselect
        @action-button="actionButton"
        :class="!data && 'tw-mt-6'"
      >
        <template #header="{ props }">
          <q-tr :props="props" class="table-header">
            <q-td v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-td>
            <q-td></q-td>
          </q-tr>
        </template>
        <template #body="{ props }">
          <q-tr class="text-left">
            <q-td v-for="col in props.cols" :key="col.name" :props="props">
              <div v-if="col.name == 'id'">
                <span>
                  {{ props.row.id }}
                </span>
              </div>
              <div v-if="col.name == 'value'">
                <span>
                  {{ $toLocaleStringBr(props.row["value"]) }}
                </span>
              </div>
              <div v-if="col.name == 'countInvoiceGrouping'">
                <span>
                  {{ props.row["countInvoiceGrouping"] }}
                </span>
              </div>
              <div v-if="col.name == 'averageInstallmentValue'">
                <span>
                  {{ $toLocaleStringBr(calcAverage(props.row)) }}
                </span>
              </div>
              <div v-if="col.name == 'dueDate'">
                <span v-if="props.row['dueDate']">
                  {{ formatDate(props.row["dueDate"]) }}
                </span>
              </div>
              <div v-if="col.name == 'attendant'">
                <span>
                  {{ props.row["attendant"] }}
                </span>
              </div>
              <div v-if="col.name == 'date'">
                {{ formatDate(props.row["date"]) }}
              </div>
              <div v-if="col.name == 'agreementInvoiceStatus'">
                <strong
                  :class="
                    isCanceled(props.row['agreementInvoiceStatusId'])
                      ? 'tw-text-red-700'
                      : 'tw-text-positive'
                  "
                >
                  {{ props.row["agreementInvoiceStatus"] }}
                </strong>
              </div>
            </q-td>
            <q-td>
              <q-btn
                @click="
                  () => {
                    openModal(props.row);
                  }
                "
                flat
                style="color: #444"
              >
                <q-icon name="mdi-eye" />
              </q-btn>
              <q-btn
                @click="deleteAgreementInvocie(props.row.id)"
                flat
                style="color: #444"
                :style="{ visibility: isCanceled(props.row['agreementInvoiceStatusId']) ? 'hidden' : 'visible' }"
              >
                <q-icon name="mdi-trash-can" id="trash-icon" />
              </q-btn>
            </q-td>
          </q-tr>
        </template>
      </jt-data-table>
    </div>
      <q-dialog
    v-model="showRemoveObservationModal"
    :maximized="maximized"
  >
    <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
      <q-header class="bg-primary">
        <q-toolbar>
          <q-toolbar-title
            >{{ $gettext('CANCEL_AGREEMENT_INVOICE') }} - {{ selectedId }}</q-toolbar-title
          >
          <q-btn v-close-popup flat round dense icon="close" />
        </q-toolbar>
      </q-header>
      <q-page-container style="max-height: 85vh" class="scroll">
        <q-input
        v-model="removeObservation"
        :label="$gettext('REASON')"
        type="textarea" />

      </q-page-container>
      <div class="row full-width q-col-gutter-lg justify-center q-py-md">
          <div class="col-lg-2 col-md-3">
            <q-btn class="full-width" color="info" @click="onFinish">
              <q-icon name="close" size="25px"/>
              {{ $gettext('CANCEL_AGREEMENT_INVOICE') }}
            </q-btn>
          </div>
        </div>
    </q-layout>
  </q-dialog>
    <service-request-simple-agreement-detail-modal
      :detail="true"
      :show="modalShow"
      :rowData="modalDetail.rowData"
      :modal-width="'90vw'"
      :modal-height="'85vh'"
      @input="resetModal"
    />
    <JtDocsViewer
      :src="fileSrc"
      :title="$gettext('SIMPLEE_AGREEMENT_REPORT')"
      pdf
      ref="reportModal"
    />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { QBtn, Dialog } from 'quasar'
import moment from 'moment'
import Situation from '../component/InvoiceSituation.vue'
import ServiceRequestSimpleAgreementDetailModal from './ServiceRequestSimpleAgreementDetailModal.vue'
import { JtDataTable, JtDocs } from 'jtech-webcomps'
import MainContentLayout from '../../../Layout/MainContentLayout.vue'
import { messageBox, repository } from 'src/jtech'
const { JtDocsViewer } = JtDocs
@Component({
  name: 'ServiceRequestSimpleAgreement',
  components: {
    MainContentLayout,
    QBtn,
    Situation,
    ServiceRequestSimpleAgreementDetailModal,
    JtDataTable,
    JtDocsViewer
  },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class ServiceRequestSimpleAgreement extends Vue {
  data = [];
  moment = moment;
  showRemoveObservationModal = false;
  removeObservation = '';
  selectedId = 0;
  modalDetail = {
    show: false,
    rowData: 'null'
  };

  columns = [
    {
      name: 'id',
      label: this.$gettext('COD'),
      align: 'center',
      value: 'id',
      field: 'id'
    },
    {
      name: 'date',
      align: 'center',
      label: this.$gettext('GENERATE_DATE'),
      value: 'date',
      field: 'date'
    },
    {
      name: 'countInvoiceGrouping',
      align: 'center',
      label: this.$gettext('INVOICE_COUNT'),
      value: 'countInvoiceGrouping',
      field: 'countInvoiceGrouping'
    },
    {
      name: 'averageInstallmentValue',
      align: 'center',
      label: this.$gettext('PLOT_VALUE_'),
      value: 'averageInstallmentValue',
      field: 'averageInstallmentValue'
    },
    {
      name: 'value',
      align: 'center',
      label: this.$gettext('AMOUNT'),
      value: 'value',
      field: 'value'
    },
    {
      name: 'agreementInvoiceStatus',
      align: 'center',
      label: this.$gettext('SITUATION'),
      value: 'agreementInvoiceStatus',
      field: 'agreementInvoiceStatus'
    },
    {
      name: 'attendant',
      align: 'center',
      label: this.$gettext('ATTENDANT'),
      value: 'attendant',
      field: 'attendant'
    }
  ];

  isCanceled (agreementInvoiceStatusId) {
    return agreementInvoiceStatusId != 50320001
  }

  calcAverage (row) {
    const value = parseFloat(String(row.value).replace(',', '.'))
    const count = parseInt(row.countInvoiceGrouping)
    if (!count || isNaN(value)) return 0
    return value / count
  }

  get modalShow () {
    return this.modalDetail.show
  }

  async deleteAgreementInvocie (id) {
    this.showRemoveObservationModal = true
    this.selectedId = id
  }

  resetModal () {
    this.modalDetail.rowData = null
    this.modalDetail.show = false
  }

  openModal (row) {
    this.modalDetail.rowData = row
    this.modalDetail.show = true
  }

  get dataTable () {
    return this.data
  }

  async mounted () {
    await this.updateTableData()
  }

  async updateTableData () {
    const reponse = await repository.resolveDatatableModel(
      'agreementInvoice.pesquisar',
      { consumerUnit: this.consumerUnit }
    )
    this.data = reponse.registros
  }

  formatDate (date) {
    return this.moment(date, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY')
  }

  async onFinish () {
    if (!this.removeObservation || this.removeObservation === '') {
      messageBox.warn(this.$gettext('CANCEL_OBSERVATION_OBRIGATORY_MESSAGE'))
      return
    }
    await repository.resolveLogic('agreementInvoice.excluir', { id: this.selectedId, observation: this.removeObservation })
    this.showRemoveObservationModal = false
    await this.updateTableData()
  }
}
export default ServiceRequestSimpleAgreement
</script>
<style lang="scss" scoped>
@import "tailwindcss/utilities";
.table-header {
  background-color: #f1f1f1;
  margin: 30px;
}

.cell-values {
  display: flex;
  flex-direction: column;
}

.colapse-area {
  background-color: #5898aa;
  display: grid;
  grid-template-columns: 32% 32% 32% 4%;
}

.box-buttom {
  grid-column-start: 4;
  grid-column-end: 5;
  grid-row-start: 1;
  grid-row-end: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 35px;
}

.colapse {
  color: #fff;
  padding: 8px 20px;
}

.row-paint-colapse {
  background-color: #f1f1f1;
}

.index {
  border-radius: 25px;
  padding: 2px 10px;
  max-height: 25px;
}

.buttons-area {
  height: 35px;
  display: flex;
}

.index-table {
  width: 50%;
  display: flex;
  align-items: center;
  gap: 15px;
}

.rigth-buttons {
  width: 50%;
  display: flex;
  justify-content: right;
}

.sub-teble-btn {
  border: none;
  background-color: #fff;
  font-size: 18px !important;
  margin-left: 15px;
}

.top-area {
  background-color: #f1f1f1;
  display: flex;
  justify-content: space-around;
  padding: 17px 0;
}

.small-span {
  font-weight: 300;
}

.block-header {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
